export const PHONE_SMS_OTP_AUTH_INTERACTION_IDS = {
  SUBMIT_PHONE: '9S_SZfYDC6',
  VERIFY_CODE: 'oneTimeCodeId',
  RESEND: 'resend',
  USE_DIFFERENT_NUMBER: 'xFKyTBaTQn',
  CHOOSE_ANOTHER_AUTH_METHOD: 'pnOqEGpL1b',
} as const;
